<div class="box-content rd-widget widget-{{widgetConfig.widgetId}} widget-two-columns-one-gap-fifty-percent" *ngIf="widgetData">
  <div class="fullWidth">
    <div class="table-part">
      <table class="widget-flex" style="height: 100%;" aria-hidden="true">
        <thead>
          <tr class="widget-ruller-flex">
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="34" class="darkGreyTableHeader"><widget-label [widget]="this" [fieldName]="'reportValuationTenureType'" [align]="'left'" [bold]="true" [color]="'white'"></widget-label></td>
          </tr>
          <tr>
            <td colspan="34" class="widget-td-onlyeditmode" *ngIf="editMode">
              <input class="widget-input-text widget-h1 widget-align-left" maxlength="255" [(ngModel)]="widgetData.reportValuationTenureType" (ngModelChange)="setDirtyFlag(true)" />
            </td>
            <td colspan="34"> <widget-value [align]="'left'" [bold]="true">{{widgetData.reportValuationTenureType}}</widget-value></td>
          </tr>
          <tr class="darkGreyTableHeader">
            <td colspan="1" (click)="addNewRow()" *ngIf="editMode"><span class="k-icon k-i-plus"></span></td>
            <td colspan="11"><widget-label [widget]="this" [fieldName]="'labelSheet'" [align]="'left'" [bold]="true" [color]="'white'"></widget-label></td>
            <td colspan="11"><widget-label [widget]="this" [fieldName]="'labelPlot'" [align]="'left'" [bold]="true" [color]="'white'"></widget-label></td>
            <td colspan="11"><widget-label [widget]="this" [fieldName]="'labelParcel'" [align]="'left'" [bold]="true" [color]="'white'"></widget-label></td>
          </tr>
          <tr *ngFor="let tenureItem of widgetData.tenureFranceRow; index as i">
            <td colspan="1" (click)="removeRow(i)" *ngIf="editMode">
              <span class="k-icon k-i-minus"></span>
            </td>
            <td colspan="11" class="widget-td-onlyeditmode" *ngIf="editMode">
              <input class="widget-input-text widget-h1 widget-align-left" maxlength="255" [(ngModel)]="tenureItem.sheet" (ngModelChange)="setDirtyFlag(true)" />
            </td>
            <td colspan="11" *ngIf="!editMode"> <widget-value [align]="'left'" [bold]="true" *ngIf="!editMode">{{tenureItem.sheet}}</widget-value></td>
            <td colspan="11" class="widget-td-onlyeditmode" *ngIf="editMode">
              <input class="widget-input-text widget-h1 widget-align-left" maxlength="255" [(ngModel)]="tenureItem.plot" (ngModelChange)="setDirtyFlag(true)" />
            </td>
            <td colspan="11" *ngIf="!editMode"> <widget-value [align]="'left'" [bold]="true" *ngIf="!editMode">{{tenureItem.plot}}</widget-value></td>
            <td colspan="11" class="widget-td-onlyeditmode" *ngIf="editMode">
              <input class="widget-input-text widget-h1 widget-align-left" maxlength="255" [(ngModel)]="tenureItem.parcel" (ngModelChange)="setDirtyFlag(true)" />
            </td>
            <td colspan="11" *ngIf="!editMode"> <widget-value [align]="'left'" [bold]="true">{{tenureItem.parcel}}</widget-value></td>
          </tr>
        <tr>
          <td colspan="34" class="space">&nbsp;</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>
